import * as React from 'react';

import { AdFoxBannerContainer } from 'shared/containers/AdFoxBannerContainer';
import { AdfoxContextProviderProps } from 'shared/utils/AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'footer',
  place__DEPRECATED: 'footerSerp',
  name__DEPRECATED: 'Listing_parallax',
};
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'dbtyp', p2: 'y' };
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 560 };

export const SeoTopBannersContainer: React.FC = () => {
  return (
    <AdFoxBannerContainer
      size={SIZE}
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
      bannerName="Adfox ТГБ баннер в футере"
    />
  );
};
